export default {
  getUserGroups: '/mrx-gateway/mrxassistmemberservice/admin/api/usergroups',
  addUserGroup: '/mrx-gateway/mrxassistmemberservice/admin/api/usergroup',
  changeUserGroup: userGroupId => `/mrx-gateway/mrxassistmemberservice/admin/api/usergroup/${userGroupId}`,
  trackingGroups: '/mrx-gateway/mrxassistmemberservice/admin/api/trackinggroups',
  benefitGroups: '/mrx-gateway/mrxassistmemberservice/admin/api/benefitgroups',
  parentGroups: '/mrx-gateway/mrxassistmemberservice/admin/api/parentgroups',
  viewSummary: '/mrx-gateway/mrxassistmemberservice/admin/api/usergroup/summary',
  userGroupsReport: '/mrx-gateway/mrxassistmemberservice/admin/api/reports/userGroups'
}
